import { reactive } from "vue";


//////////////////////////////////////////////////
//  STORE
//////////////////////////////////////////////////


export type BotInstance = {
    permissions: {
        global: bigint;
        channels: Record<string, bigint>;
    };
};

export type GuildData = {
    id: string;
    name: string;
    icon: string;
    bot: BotInstance | null;
    hasAccess: boolean;
    permissions?: string;
    owner?: boolean;
    canInvite?: boolean;
    memberCount?: number;
    approximateOnlineCount?: number | null;
};

export type SelectedGuildAccessError = {
    code    : string;
    guildId : string;
    message : string;
};

export type Store = {
    loading: boolean;
    me: {
        id: string;
        globalName?: string | null;
        username: string;
        avatar: string | null;
        authMode?: "oauth" | "handoff";
        botClientId?: string;
        guildMember: {
            guildId: string;
        } | null;
        guilds:     GuildData[];
        selectedGuildAccessError?: SelectedGuildAccessError;
    } | null;
    selectedGuild: GuildData | null;
};

export default reactive<Store>({
    loading: true,
    me: null,
    selectedGuild: null,
});
